<template>
    <span class="">{{ displayQuantity }} <span>{{ label }}</span></span>
</template>

<script>
export default {
  props: {
    metric: {
      type: Number
    },
    quantity: {
      type: [String, Number]
    }
  },
  data () {
    return {
      displayQuantity: 0
    }
  },
  computed: {
    label: function () {
      var hmetric = this.$crx.metrics.humanizeDBMetric(this.quantity, this.metric)
      // this.displayQuantity = Math.round(hmetric.quantity * 100) / 100
      this.displayQuantity = this.$cmath.toDecimal(hmetric.quantity)
      return this.$crx.metrics.getMetricRowFromSid(hmetric.sid).symbol
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.font-bold {
  font-weight: 700;
}
</style>

